import React from 'react';
import { Link } from 'react-router-dom';

const RecentOrders = ({ orders = [], loading }) => {
  const getBadgeClass = (status) => {
    const s = status ? status.toLowerCase() : '';
    if (s.includes('completed') || s.includes('delivered')) return 'badge-completed';
    if (s.includes('processing') || s.includes('shipped')) return 'badge-processing';
    return 'badge-pending';
  };

  return (
    <div className="table-card-box">
      <div className="card-header-flex">
        <h3 className="card-title-text">Recent Orders</h3>
        <Link to="/admin/orders" className="view-all-link">View All</Link>
      </div>

      <table className="custom-data-table">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Customer</th>
            <th>Date</th>
            <th>Status</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan={5} style={{ padding: '20px', textAlign: 'center', color: '#64748b' }}>Loading recent orders...</td></tr>
          ) : !orders || orders.length === 0 ? (
            <tr><td colSpan={5} style={{ padding: '20px', textAlign: 'center', color: '#64748b' }}>No recent orders.</td></tr>
          ) : (
            orders.map((row) => (
              <tr key={row.id}>
                <td style={{ fontWeight: 700, color: '#0f172a' }}>{row.order_number || `#ORD-${row.id}`}</td>
                <td>{row.customer_name || 'Customer'}</td>
                <td style={{ color: '#64748b' }}>{new Date(row.created_at).toLocaleDateString()}</td>
                <td>
                  <span className={`badge-pill ${getBadgeClass(row.order_status)}`}>
                    {row.order_status || 'Processing'}
                  </span>
                </td>
                <td style={{ fontWeight: 700, color: '#0f172a' }}>£{Number(row.total_amount || 0).toFixed(2)}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RecentOrders;
